import { RUN_PHASE_LABEL } from './run-state.js';
export const LANE_COLUMNS = [
    { key: 'queued', label: 'Queued' },
    { key: 'running', label: 'Running' },
    { key: 'verifying', label: 'Checking & landing' },
    { key: 'landed', label: 'Landed today' },
];
export const LANE_STATE_LABEL = {
    queued: 'Queued',
    running: 'Running',
    blocked: 'Blocked',
    'needs-you': 'Needs you',
    verifying: 'Verifying',
    landing: 'Landing',
    landed: 'Landed',
    unverified: 'Unverified',
    hidden: 'Hidden',
};
const LIVE = ['working', 'making-progress', 'idle', 'not-started', 'syncing'];
const BAD = ['stalled', 'looping', 'blocked-environment', 'failed', 'offline'];
const DONE_RUN = ['finished', 'review', 'ready'];
/** Local midnight of the day containing `now`. */
export function localDayStart(now) {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
}
/** The column a blocked / needs-you task keeps: where it was last active. */
function lastColumn(t, run) {
    if (t.status === 'review' || t.status === 'landing')
        return 'verifying';
    if (run && DONE_RUN.includes(run.phase))
        return 'verifying';
    if (t.status === 'running' || run)
        return 'running';
    return 'queued';
}
export function laneTaskState(task, run, landing, ctx) {
    const s = task.status;
    if (s === 'cancelled')
        return { state: 'hidden', column: null };
    if (s === 'done') {
        if (task.landedAt == null)
            return { state: 'hidden', column: null };
        return task.landedAt >= localDayStart(ctx.now)
            ? { state: 'landed', column: 'landed' }
            : { state: 'landed', column: null, earlier: true };
    }
    if (s === 'landing' || landing?.active)
        return {
            state: 'landing',
            column: 'verifying',
            subLabel: landing?.step ? `Landing… ${landing.step}` : 'Landing…',
        };
    if (run?.phase === 'waiting' || ctx.openDecision)
        return { state: 'needs-you', column: lastColumn(task, run) };
    // G14: paused on a usage limit is not blocked (it resumes by itself): it stays in Running.
    if (run?.phase === 'paused-limit' && s !== 'blocked')
        return { state: 'running', column: 'running', subLabel: run.reason ?? 'Paused · usage limit' };
    if (s === 'blocked' || (run && BAD.includes(run.phase))) {
        const reason = task.blockedReason ??
            (run && BAD.includes(run.phase) ? (run.reason ?? RUN_PHASE_LABEL[run.phase]) : undefined);
        return { state: 'blocked', column: lastColumn(task, run), ...(reason ? { reason } : {}) };
    }
    if (s === 'review' || (run && DONE_RUN.includes(run.phase)))
        return { state: 'verifying', column: 'verifying' };
    if (s === 'proposed')
        return { state: 'queued', column: 'queued', proposed: true, subLabel: 'Proposed' };
    if (s === 'running' || (run && LIVE.includes(run.phase)))
        return { state: 'running', column: 'running' };
    if (s === 'unknown')
        return { state: 'unverified', column: 'queued', subLabel: 'Unverified' };
    return { state: 'queued', column: 'queued' };
}
//# sourceMappingURL=lane-state.js.map